import React from "react";
import {CircularProgress,} from "@mui/joy";

// components
import CommonPaginatedTable from "../../Common/CommonPaginatedTable";
import ContactTeamDelete from "./ContactTeamDelete";
import ContactTeamCreate from "./ContactTeamCreate";
import UserSubscriberContext from "../../../context/UserSubscriberContext";
import BaseApi from "../../../utils/BaseApi";
import CallsListModal from "../../Communication/CallsListModal";


class ContactTeamTab extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            team: null,
        };
    }

    async componentDidMount() {
        await this.retrieveTeam();
    }

    async retrieveTeam() {
        const url = `opp_contact_team/`;
        const api = new BaseApi();
        const params = {
            opportunity: this.props.opportunity.id
        };
        let response = await api.get(url, params);
        this.setState(
            {
                team: response.data.results
            }
        );
    }

    render() {
        if (!this.state.team) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedTable
                data={this.state.team}
                extraComponents={[
                    {
                        component: ContactTeamCreate,
                        componentProps: {
                            opportunity: this.props.opportunity
                        }
                    }
                ]}
                callBack={this.retrieveTeam.bind(this)}
                fields={[
                    {
                        title: 'ФИО',
                        name: ['contact.last_name', 'contact.first_name', 'contact.patronymic'],
                        linkPattern: '/contact/detail/:linkParam',
                        linkParam: 'contact.id',
                        linkTarget: '_blank',
                        visible: true,
                        copy: true,
                    },
                    {
                        title: 'Телефон',
                        name: 'contact.primary_phone',
                        visible: true,
                        copy: true,
                    },
                    {
                        title: '',
                        component: CallsListModal,
                        componentProps: {
                            buttonIconOnly: true,
                        },
                        visible: true,
                        width: '30px',
                    },
                    {
                        title: 'Электронная почта',
                        name: 'contact.primary_email',
                        visible: true,
                        copy: true,
                    },
                    {
                        title: 'Роль',
                        name: 'role_human',
                        visible: true,
                        chip: true,
                        color_rule: (value, comparison) => (value),
                        color_value: 'color',
                    },
                    {
                        title: '',
                        visible: true,
                        component: ContactTeamDelete,
                        callBack: this.retrieveTeam.bind(this),
                    },
                ]}
            />
        )
    }
}

export default ContactTeamTab
